import Marquee from "react-fast-marquee";

const ITEMS = ["Websites", "Web Apps", "Mobile Apps", "Branding", "Marketing", "Social Media", "Software", "Strategy"];
const DOTS = ["bg-amber-500", "bg-rose-500", "bg-purple-500", "bg-blue-500", "bg-teal-500", "bg-emerald-500"];

export default function EditorialMarquee() {
    return (
        <div className="overflow-hidden border-y border-slate-200 bg-white py-8 md:py-12" data-testid="editorial-marquee">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {ITEMS.map((item, i) => (
                    <span key={item} className="mx-8 flex items-center gap-16">
                        <span className="outline-text whitespace-nowrap text-5xl font-black uppercase tracking-tighter md:text-8xl">
                            {item}
                        </span>
                        <span className={`h-3 w-3 rounded-full md:h-4 md:w-4 ${DOTS[i % DOTS.length]}`} />
                    </span>
                ))}
            </Marquee>
        </div>
    );
}
